import { render, staticRenderFns } from "./TrendlineWidget.vue?vue&type=template&id=dee925d8"
import script from "./TrendlineWidget.vue?vue&type=script&lang=js"
export * from "./TrendlineWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports